import React, { Component } from "react";
import Modal from "react-bootstrap/lib/Modal";
import { isEmpty } from "lodash";
import {isSunday}  from '../utils/DateHelpers';

import {
  SLBTxtBox,
  SLBTextarea,
  datePicker
} from "../utils/Forms";

export default class PrayerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      prayer: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.prayerDateChanged = this.prayerDateChanged.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setPrayer(nextProps.currentPrayer);
  }

  setPrayer(data = {}) {
    const prayer = {
      prayer_date: data.prayer_date,
      scriptures: data.scriptures,
      description: data.description || "",
      id: data.id || 0
    };

    this.setState({ prayer });
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    let newPrayer = { ...this.state.prayer, [name]: value };
    this.setState({ ...this.state, prayer: newPrayer });
  }

  prayerDateChanged(updatedDate) {
    let updatedPrayer = { ...this.state.prayer, prayer_date: updatedDate };
    this.setState({ ...this.state, prayer: updatedPrayer });
  }

  handleTimeChanged(field, newTime) {
    let newPrayer = { ...this.state.prayer, [field]: newTime };
    this.setState({ ...this.state, prayer: newPrayer });
  }

  isPrayerValid(prayer = {}) {
    let errors = {};
    const {description, scriptures, prayer_date } = prayer;
    if (isEmpty(description)) {
      errors["description"] = "Description is required!";
    }

    if (isEmpty(scriptures)) {
      errors["scriptures"] = "Scripture(s) is required!";
    }

    if (isEmpty(prayer_date)) {
      errors["prayer_date"] = "Prayer date is required!";
    }
    this.setState({ errors });
    return isEmpty(errors);
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isPrayerValid(this.state.prayer)) {
      this.props.savePrayer(this.state.prayer);
    }
  }

  render() {
    let {
      id,
      scriptures,
      description,
      prayer_date,
    } = this.state.prayer;

    const { errors } = this.state;
    let buttonText = id > 0 ? "Update" : "Create";

    return (
      <Modal show={this.props.showModal} onHide={() => this.props.hideModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Prayer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <form onSubmit={this.handleSubmit}>
              <div className="clearfix">

                <div className="col-md-12">
                  {datePicker(
                    "Date",
                    "prayer_date",
                    prayer_date,
                    this.prayerDateChanged,
                    { errors, klass: "col-md-6" }
                  )}
                </div>
                <div className="col-md-12">
                  <SLBTextarea
                    label="Details"
                    name="description"
                    value={description}
                    context={this}
                    attrs={{ errors, klass: "col-md-12", rows: "6" }}
                  />
                </div>
                <div className="col-md-12">
                  <SLBTxtBox
                    label="Scriptures"
                    name="scriptures"
                    value={scriptures}
                    context={this}
                    attrs={{ errors, klass: "col-md-12" }}
                  />
                </div>

                <br />
                <div className="col-md-12 edit-buttons-pane">
                  <input
                    className="btn btn-success pull-right"
                    type="submit"
                    value={buttonText}
                  />
                  <a
                    className="btn btn-default pull-right"
                    style={{ marginRight: 10 }}
                    onClick={() => this.props.hideModal()}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PrayerModal.js